import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

export const useParentStyles = makeStyles(() => createStyles({
  root: {

  },
  content: {
    borderRadius: "4px",
    padding: "6px",
    height: '32px',
  },
  label: {
    color: "rgba(39, 58, 57, 0.8)",
    fontSize: "12px",
    lineHeight: "100%",
    fontWeight: "bold",
    background: "none !important",
  },
  selected: {
    "& $content": {
    },
    "& $label": {
      background: "none !important",
      color: "#65AC1E",
    }
  },
}));

export const useItemStyles = makeStyles(() => createStyles({
  root: {
    marginBottom: '2px',
    "& $content:hover": {
      background: "rgba(51, 51, 51, 0.05)",
    }
  },
  content: {
    borderRadius: "4px",
    padding: "6px",
    marginLeft: '-32px',
    paddingLeft: '38px',
    height: '32px',
    width: 'calc(100% + 32px)'
  },
  label: {
    color: "rgba(39, 58, 57, 0.8)",
    fontSize: "12px",
    lineHeight: "100%",
    fontWeight: "bold",
    background: "none !important",
  },
  selected: {
    "& $content": {
      background: "rgba(101, 172, 30, 0.2)",

    },
    "& $label": {
      background: "none !important",
      color: "#65AC1E",
    }
  },
}));

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    userSelect: "none",
    width: '100%',
    height: '100%',
  },
  root: {
    paddingTop: theme.spacing(3),
    margin: 'auto',
    display: 'flex',
    justifyContent: 'stretch',
    alignItems: 'stretch',
  },
  box: {
    flex: 1,
    width: '100%',
  },
  item: {
    '& span': {
      fontSize: '12px',
      lineHeight: '180%',
      fontWidth: 'bold',
    }
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    height: "inherit",
    position: 'relative',
    zIndex: 1,
    '&:before': {
      zIndex: 0,
      background: theme.palette.background.default,
      width: theme.spacing(1.2),
      height: '100%',
      position: 'absolute',
      left: theme.spacing(4.5),
      top: 0,
      content: '" "',
    },
  },
  button: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(0.5),
    background: theme.palette.background.default,
    border: 'none !important',
    transform: 'scaleX(0.8) scaleY(1.5)',
    fontWeight: 'bold',
    '&:hover': {
      background: 'rgb(239, 239, 239)', // TODO
      border: 'none',
    }
  },
}));

export const useInputStyles = makeStyles((theme: Theme) => ({
  adornedEnd: {
    '& g *': {
      stroke: '#a2a9a9'
    },
    width: theme.spacing(2),
    height: theme.spacing(2),
    boxSizing: 'content-box',
    paddingRight: theme.spacing(1),
  },
  root: {
    width: '50%',
    maxWidth: "357px",
    height: "30px",
    padding: "4px 12px",
    background: "rgba(51, 51, 51, 0.05)",
    borderColor: "rgba(43, 57, 64, 0.07)",
    borderRadius: "4px",
    borderStyle: "solid",
    borderWidth: "1px",
    "&:before": {
      display: "none"
    },
    "&:after": {
      display: "none"
    },
    "&.focus": {
      borderColor: theme.palette.primary.main
    },
  },
  formControl: {
    "&.focus": {
      borderColor: theme.palette.primary.main
    }
  },
  disabled: {},
  underline: {},
  error: {},
  multiline: {},
  fullWidth: {},
  input: {
    userSelect: "none",
    fontSize: '14px',
    lineHeight: '17px',
  },
  inputMarginDense: {},
  inputMultiline: {},
  inputTypeSearch: {}
}));